import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <div className="copyright">
        <p>
          Copyright © by{" "}
          <a href="http://coinworks.co/" target="_blank"  rel="noreferrer">
            Coin Works
          </a>{" "}
          2021
        </p>
      </div>
    </div>
  );
};

export default Footer;
